export default {
	es: {

		enlaces : {
			home : '/candidatos',
			miscandidaturas : '/candidatos/mis-candidaturas',
			micv : '/candidatos/mi-cv',
			login : '/candidatos/login',
			oportunidadesinternacionales : '/candidatos/portales-globales',
			ofertas : '/candidatos/ofertas',
			oferta : '/candidatos/oferta',
			rgpd : '/candidatos/rgpd',
			logout : '/candidatos/logout',
			politicaprivacidad : '/candidatos/politica-de-privacidad',
			avisolegal : '/candidatos/aviso-legal',
		},
		meses : ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"]

	},
	en: {
		
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js